export default __webpack_public_path__ + "static/O0059-f0c4be6527d15df91fd3acbb763b056e.png";